export default __webpack_public_path__ + "static/media/WM0370.34I-43144_-25805_0.a178d165.jpg";